module.exports = __webpack_public_path__ + "static/media/departmentsSelected.a50b43db.svg";